import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchMarketplacesData from '../Services/fetchMarketplacesData';

export default function useMarketplacesQuery() {
	const { accessToken } = useAuth();

	const marketplacesQuery = useQuery({
		queryKey: ['marketplaces'],
		queryFn: () => fetchMarketplacesData({ accessToken }),
		staleTime: Infinity,
		retry: false,
	});

	return marketplacesQuery;
}
